import { useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="w-full shrink-0 bg-background-50">
      <div className="w-full px-6 md:px-10 lg:px-14">
        <div className="flex items-start justify-between py-5 md:py-6">
          {/* Logotype — editorial masthead */}
          <a
            href="#top"
            aria-label="Maison — return to top"
            className="group inline-flex items-center gap-3 cursor-pointer"
          >
            <span className="w-9 h-9 flex items-center justify-center bg-foreground-950 text-background-50 font-heading italic font-medium text-[20px] leading-none tracking-[-0.02em]">
              M
            </span>
            <span className="font-heading italic font-medium text-foreground-950 text-[22px] md:text-[24px] tracking-[-0.025em] leading-none">
              Maison
            </span>
          </a>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-10 lg:gap-12 pt-1.5">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="font-sans text-[15px] text-foreground-900 hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Mobile trigger */}
          <button
            type="button"
            aria-label="Open menu"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-foreground-300 text-foreground-950 cursor-pointer"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="md:hidden pb-6 flex flex-col gap-4 border-t border-foreground-200/60 pt-4">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setOpen(false)}
                className="font-sans text-[15px] text-foreground-900 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}